import { transformDateValue } from 'core/js/FormUtils';
export const getCategoryView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let categoryList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Status Id","fieldValue":transformDataValue(data.statusid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Image URL","fieldValue":transformDataValue(data.imageurl,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          categoryList.push(card);
  })
  return categoryList;
}